import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DataService } from '../services/data.service';
import { TokenService } from '../services/token.service';
import { Role, RoleRoutes } from '../constants/roles';

export const SectionGuard: CanActivateFn = (route, state) => {
  const dataService = inject(DataService);
  const tokenService = inject(TokenService);
  const router = inject(Router);

  // التحقق من الـ role بتاع المستخدم من التوكين
  const decoded = tokenService.decodeToken();
  const userRole = decoded?.roles as Role;
  const roleConfig = RoleRoutes[userRole];

  // لو مفيش role معروف → logout
  if (!roleConfig) {
    tokenService.fullCleanup();
    router.navigate(['/login']);
    return false;
  }

  const currentSection = dataService.getSelectedSection();
  const requestedPath = route.routeConfig?.path || '';

  // لو الـ section الحالي مش بتاع الـ role → ارجع للـ section الصح
  if (!roleConfig.sections.includes(currentSection)) {
    dataService.setSelectedSection(roleConfig.section);
    router.navigate([roleConfig.defaultRoute]);
    return false;
  }

  // تعريف الـ routes لكل section مع الـ default route
  const sectionConfig: { [key: string]: { routes: string[], default: string } } = {
    'BtakkaInterface': {
      routes: ['FinishingInspectionRequest', 'ContractRequest', 'Planes','Home','Protofolio', 'ProtofolioDetails/:id'],
      default: 'FinishingInspectionRequest'
    },
    'BtakkaErp': {
      routes: ['Account', 'Cost-Center','Journal-Type'],
      default: 'Account'
    },
    'BtakkaOperation': {
      routes: ['Operation', 'Operation/:tab', 'Settling', 'SettlementDetails/:id','Management', 'EngineersBalance','UnitsBalance',
        'UnitDashboard/:id', 'ImpressSettlement/:id/:tab', 'EngineerDetails/:id/:tab', 'StatementExpenses/:id', 'StatementExpensesDetails/:id/:index',
        'AccountStatement/:id', 'UnitDetails/:id'],
      default: 'Settling'
    }
  };

  const config = sectionConfig[currentSection];

  if (!config) {
    dataService.setSelectedSection(roleConfig.section);
    router.navigate([roleConfig.defaultRoute]);
    return false;
  }

  // التحقق من أن الـ route يتبع الـ section المختار
  const isAllowed = config.routes.includes(requestedPath);

  if (!isAllowed) {
    // لو الـ route مش تابع للـ section، ارجع للـ default route بتاع الـ section ده
    router.navigate([config.default]);
    return false;
  }

  // // ربط كل route بالـ claim المطلوب
  // const routeClaimMap: { [key: string]: string } = {
  //   'Account':                          'ManageAccounts',
  //   'Cost-Center':                      'CostCenter',
  //   'Protofolio':                       'Project',
  //   'ProtofolioDetails/:id':            'Project',
  //   'FinishingInspectionRequest':       'FinishingInseption',
  //   'ContractRequest':                  'CompanyService',
  //   'Planes':                           'Plan',
  //   'EngineersBalance':                 'EngineersTotalBalance',
  //   'UnitsBalance':                     'UnitsTotalBalance',
  //   'Settling':                         'Settlement',
  //   'Home':                             'Settlement',
  //   'SettlementDetails/:id':            'Settlement',
  //   'Management':                       'Management',
  //   'Operation/:tab':                   'Units',
  //   'UnitDashboard/:id':                'Units',
  //   'ImpressSettlement/:id/:tab':       'Units',
  //   'StatementExpenses/:id':            'Units',
  //   'StatementExpensesDetails/:id/:index': 'Units',
  //   'AccountStatement/:id':             'Units',
  //   'UnitDetails/:id':                  'Units',
  //   'EngineerDetails/:id/:tab':         'Engineers',
  // };

  // const requiredClaim = routeClaimMap[requestedPath];

  // // لو الـ route محتاج claim وصاحبه مش موجود → ارجع للـ default
  // if (requiredClaim && !dataService.hasClaim(requiredClaim)) {
  //   router.navigate([config.default]);
  //   return false;
  // }

  return true;
};
